import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function PaymentResult({ cancelled = false }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancelled" : "polling");
  const [plan, setPlan] = useState(null);
  useEffect(() => {
    if (cancelled || !sessionId) return;
    let tries = 0;
    const tick = async () => {
      try {
        const r = await api.get(`/billing/status/${sessionId}`);
        setPlan(r.data.plan);
        if (r.data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(r.data.payment_status)) return setState("failed");
      } catch (e) { /* retry */ }
      if (++tries < 10) setTimeout(tick, 2000); else setState("timeout");
    };
    tick();
  }, [sessionId, cancelled]);
  const M = {
    polling: [Loader2, "Confirming your payment…", "This takes a few seconds.", "animate-spin text-primary"],
    paid: [CheckCircle2, `You're on the ${plan || ""} plan`, "Your subscription is active. Limits have been lifted across your organisations.", "text-emerald-500"],
    failed: [XCircle, "Payment not completed", "The checkout session expired or failed. No charge was made.", "text-rose-500"],
    timeout: [XCircle, "Still processing", "We could not confirm the payment yet. Check Billing in a minute.", "text-amber-500"],
    cancelled: [XCircle, "Checkout cancelled", "No charge was made. You can pick a plan any time.", "text-muted-foreground"],
  }[state];
  const Icon = M[0];
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="surface p-10 max-w-md text-center" data-testid={`payment-${state}`}>
        <Icon size={48} className={`mx-auto ${M[3]}`} />
        <h1 className="font-display text-2xl font-bold mt-4">{M[1]}</h1>
        <p className="text-sm text-muted-foreground mt-2">{M[2]}</p>
        <div className="flex justify-center gap-2 mt-6"><Button asChild><Link to="/app" data-testid="payment-continue">Go to workspace</Link></Button><Button variant="outline" asChild><Link to="/billing" data-testid="payment-billing">Billing</Link></Button></div>
      </div>
    </div>
  );
}
